.container {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: var(--cxy-color-white);
  font-family: var(--cxy-font-family-sans);
}

.title {
  margin: 0;
  padding-bottom: 16px;
  color: var(--cxy-color-midnight-blue-600);
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  border-bottom: 1px solid var(--cxy-color-grey-200);
}

.link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  color: var(--cxy-color-midnight-blue-600);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
}
.link:hover,
.link:focus-visible {
  text-decoration: underline;
}

/* Fixed box so rows stay aligned when only some items have an icon. */
.icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

/* Size repeated rather than inherited from `.link`: the global reset sets `span { font-size: 15px }`,
   which beats an inherited value. */
.linkText {
  min-width: 0;
  font-size: 16px;
  line-height: 24px;
}
